export default __webpack_public_path__ + "static/media/progress.71c70454.svg";